import Proxy from './Proxy';

export class AuthProxy extends Proxy {
  constructor() {
    super(`${process.env.REACT_APP_API_URL}`);
  }

  getAccount() {
    return this.submit('get', `/account`);
  }

  check(payload) {
    return this.submit('post', '/account/check', payload);
  }

  login(payload) {
    return this.submitLogin('post', '/token', payload);
  }

  register(payload) {
    return this.submit('post', '/account', payload);
  }

  forgotPassword(payload) {
    return this.submit('post', '/account/sendresetpasswordmessage', payload);
  }

  forgotPasswordConfirm(payload) {
    return this.submit('post', '/account/resetpassword', payload);
  }

  confirmEmail(payload) {
    return this.submit('post', '/account/confirmemail', payload);
  }

  confirm(payload) {
    return this.submit('post', '/account/confirm', payload);
  }

  changePassword(payload) {
    return this.submit('post', '/account/changePassword', payload.data);
  }

  resetPassword(payload) {
    return this.submit('post', '/account/resetPasswordConfirm', payload);
  }

  patch(payload) {
    return this.submit('patch', '/account', payload);
  }

  deletePicture() {
    return this.submit('delete', '/account/deletepicture');
  }

}



// WEBPACK FOOTER //
// ./src/proxies/AuthProxy.js